import type { ComponentProps } from "react";

import { cn } from "@/lib/utils";

export function Select({ className, ...props }: ComponentProps<"select">) {
	return <select className={cn("control-field h-11 py-1 md:h-10", className)} {...props} />;
}
